require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.map');
require('../modules/es7.map.to-json');
module.exports = require('../modules/_core').Map;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-helmet/~/core-js/fn/map.js
 ** module id = 1212
 ** module chunks = 0
 **/